import React from 'react';

const MessageAndAttachmentSection = ({ 
  formData, 
  handleChange, 
  handleFileChange, 
  addNotification, 
  isSubmitting 
}) => {
  return (
    <div className="lg:col-span-2">
      <h3 className="text-lg font-semibold text-black font-poppins mb-4 border-b-2 border-gray-200 pb-2">
        Message Details & Attachments (Optional)
      </h3>

      <div className="space-y-6">
        {/* Message Details Section */}
        <div className="relative">
          <label htmlFor="specificProblem" className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Specific Problem
          </label>
          <textarea
            id="specificProblem"
            name="specificProblem"
            rows={4}
            value={formData.specificProblem}
            onChange={handleChange}
            disabled={isSubmitting}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg font-poppins transition-all duration-300 focus:ring-2 focus:ring-black focus:border-black disabled:opacity-50 disabled:cursor-not-allowed resize-vertical"
            placeholder="Describe the specific problem you're experiencing..."
          />
        </div>

        {/* Attachments Section */}
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
            Attachments
          </label>
          <div className="w-full max-w-md">
            <input
              accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              style={{ display: 'none' }}
              id="file-upload"
              type="file"
              onChange={(e) => handleFileChange(e, addNotification)}
              disabled={isSubmitting}
            />
            <label htmlFor="file-upload" className="w-full block">
              <div className="w-full py-3 px-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-gray-400 transition-colors cursor-pointer text-center font-poppins text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed">
                Upload File (PDF, DOC, DOCX)
              </div>
            </label>
            
            {formData.file && (
              <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200 flex items-center justify-center">
                <p className="font-poppins text-sm text-black">
                  Selected file: {formData.file.name}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageAndAttachmentSection;